import ProjectSettingsForm from "./ProjectSettingsForm";
import React from "react";
import SideModal from "../../elements/Modal/SideModal";

const CreateProjectSideModal = ({
  title,
  sideModalVisible,
  setSideModalVisible,
  companyId,
  currencyId,
  inputProject,
  saveProject,
  sendNotification,
  tiersId
}) => {
  const project = {
    name: inputProject || "",
    tiersClientId: null,
    projectType: "",
    tiersCollaboratorId: null,
    dateFinPrevue: null,
    active: true
  };
  return (
    <SideModal
      title={title}
      width="medium-wide"
      visible={sideModalVisible}
      handleClose={() => setSideModalVisible(false)}>
      <ProjectSettingsForm
        inSideModal
        sendNotification={sendNotification}
        companyId={companyId}
        currency={currencyId}
        tiersId={tiersId}
        project={project}
        saveProject={saveProject}
        goBack={() => setSideModalVisible(false)}
        cancel={() => setSideModalVisible(false)}
      />
    </SideModal>
  );
};

export default CreateProjectSideModal;
